import { render, staticRenderFns } from "./OrganizationIpaAddressTable.vue?vue&type=template&id=0477e8a8&"
import script from "./OrganizationIpaAddressTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationIpaAddressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports